import romana from './romana'
import magyar from './magyar'

export default {
    hu: magyar,
    ro: romana
}